import { MonitorViewType } from '../../monitor/models/monitor';
import { CompanyType } from '../../monitor/models/company';
import { RetailPriority, MemberPriority } from '../../monitor/models/priority';
import { MonitorActionTypes, MonitorActionUnion } from './actions';
import { MonitorState } from './state';

export const monitorDefaultState: MonitorState = {
  viewType: MonitorViewType.Overview,
  selectedMaturityId: undefined,
  filterByCompanyType: undefined,
  filterByMemberPriority: undefined,
  filterByRetailPriority: undefined
};

export function monitorReducer(
  state = monitorDefaultState,
  action: MonitorActionUnion
): MonitorState {
  switch (action && action.type) {
    case MonitorActionTypes.SetViewType:
      return { ...state, viewType: action.payload as MonitorViewType };

    case MonitorActionTypes.SetSelectedMaturityId:
      return { ...state, selectedMaturityId: action.payload as string };

    case MonitorActionTypes.SetFilterByCompanyType:
      return { ...state, filterByCompanyType: action.payload as CompanyType };

    case MonitorActionTypes.SetFilterByMemberPriority:
      return {
        ...state,
        filterByMemberPriority: action.payload as MemberPriority
      };

    case MonitorActionTypes.SetFilterByRetailPriority:
      return {
        ...state,
        filterByRetailPriority: action.payload as RetailPriority
      };

    default:
      return state;
  }
}

export const getViewType = (state: MonitorState) => state.viewType;
export const getSelectedMaturity = (state: MonitorState) =>
  state.selectedMaturityId;
export const getCompanyTypeFilter = (state: MonitorState) =>
  state.filterByCompanyType;
export const getMemberPriorityFilter = (state: MonitorState) =>
  state.filterByMemberPriority;
export const getRetailPriorityFilter = (state: MonitorState) =>
  state.filterByRetailPriority;
